import { useEffect, useState } from 'react';
import { usePublicClient, useWalletClient } from 'wagmi';
import { createPublicClient, custom } from 'viem';

/**
  This creates a client which functions like a publicClient
  But with its RPC (aka "transport") taken from user's walletClient
*/
function useCustomClientRO() {
  const publicClient = usePublicClient(); // placeholder for proper type hint
  const walletClient = useWalletClient();

  const [customClient, SetCustomClient] = useState(publicClient);

  useEffect(() => {
    CreateClient();
  }, [walletClient?.data?.account?.address]);

  useEffect(() => {
    /*
    console.log(`custom client changed: ${customClient}`);
    //console.log(customClient?.chain?.rpcUrls);
    console.dir(customClient, {depth: 8});
    console.log(`----------- public -----------`);
    console.dir(publicClient, {depth: 8});
    */
  }, [customClient])



  function CreateClient() {
    if (!walletClient?.data?.transport)
      return;
    try {
      const client = createPublicClient({
        chain: walletClient.data.chain,
        transport: custom(walletClient.data.transport),
      });
      SetCustomClient(client);
    } catch (e) {
      console.error(`Error client custom client`);
      console.error(e);
    }
  }

  return customClient;
};

export default useCustomClientRO;
